import styled, { css } from 'styled-components';

import { Annotation } from './text';

export const Tag = styled(Annotation)`
  ${(props) =>
    props.overImage &&
    css`
      position: absolute;
      top: 1rem;
      left: 1rem;
    `}
  padding: 0.375rem 0.75rem;
  border: 2px solid ${(props) => props.theme.primary};
  border-radius: 0.25rem;
  font-weight: 600;
  line-height: 100%;
  color: ${(props) => props.theme.primary};
  background-color: ${(props) => props.theme.noContrast};
  z-index: 1;
`;
